<template>
  <div>
    <h2 class="mt-6">
      Variables
      <v-btn color="primary" dark class="mb-2">Nueva</v-btn>
    </h2>
    <v-card class="mt-5" tile>
      <v-list-item v-for="variable in variables" :key="variable.id">
        <v-list-item-content>
          <v-list-item-title
            ><v-row no-gutters>
              <v-col>
                {{ variable.name }}
              </v-col>
              <v-col>
                {{ variable.value }}
              </v-col>
              <v-col>
                <v-icon small class="mr-2">
                  mdi-pencil
                </v-icon>
                <v-icon small>
                  mdi-delete
                </v-icon>
              </v-col>
            </v-row></v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>
    </v-card>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["variables"]),
  },
};
</script>
